import { render, staticRenderFns } from "./NewPayslip.vue?vue&type=template&id=32861a01"
import script from "./NewPayslip.vue?vue&type=script&lang=js"
export * from "./NewPayslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports